const updateButtonType = (data) => {
  return {
    type: 'SET_SUBMIT_BUTTON_TYPE',
    data,
  };
};

export {updateButtonType};
